import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    permissions: [],
    permission: {}
  },
  mutations: {
    index(state, payload) {
      state.permissions = payload
    },
    show(state, payload) {
      state.permission = payload
    }
  },
  actions: {
    index({ commit }, payload) {
      return axios.get(`${ENV.API_URL}/api/permissions${payload || ''}`).then((res) => {
        commit('index', res.data)
        return res.data;
      })
    },
    show({ commit }, payload) {
      return axios.get(`${ENV.API_URL}/api/permissions/${payload}`).then((res) => {
        commit('show', res.data)
        return res.data;
      })
    },
    create({ commit }, payload) {
      return axios.post(`${ENV.API_URL}/api/permissions`, payload).then((res) => {
        commit('show', res.data)
        return res.data;
      })
    },
    update({ commit }, payload) {
      return axios.put(`${ENV.API_URL}/api/permissions/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
        return res.data;
      })
    }
  },
  getters: {
    permissions: state => {
      return state.permissions
    },
    permission: state => {
      return state.permission
    }
  },
  modules: {}
}
